// removed by extract-text-webpack-plugin
module.exports = {"content":"_17uZbow5xVHV2jla1TriQN","header":"_1SqcbbbA3pQGUZpjjnRANW","logo":"_2seY5nPa63DhvJ69akzNDV","create":"_15lLfJt-eLHyRy8fijjSbm","card":"_2hXjUuAC8qh9lvhFpmI6cy","card_head":"_1DxMJK0P854bDFPujHcvb1","img":"_2LTErkliiOkr-tQzRff2Xs","status":"K3GfLaIcJOGc9sIta9zQQ","action":"_14fpquOcgFLamVKeYfrLC_"};


//////////////////
// WEBPACK FOOTER
// ./src/views/live/css/streams.module.css
// module id = 341
// module chunks = 0